import MarketSnapshotsBaseController from 'lumen/controllers/market/snapshots/base';
import type MarketSnapshotsPickupRoute from 'lumen/routes/market/snapshots/pickup';
import { SNAPSHOT_VIEW_CONFIG } from 'lumen/utils/constants/market-snapshots-constants';
import type { ModelFrom } from 'lumen/utils/routes';

// No data preferences: the popover is hidden on this view.
export default class MarketSnapshotsPickupController extends MarketSnapshotsBaseController {
  declare model: ModelFrom<MarketSnapshotsPickupRoute>;

  readonly config = SNAPSHOT_VIEW_CONFIG.pickup;
}
